import { render, staticRenderFns } from "./fee-lab-kpi-strip.vue?vue&type=template&id=e9d7b2b6&scoped=true&"
import script from "./fee-lab-kpi-strip.vue?vue&type=script&lang=js&"
export * from "./fee-lab-kpi-strip.vue?vue&type=script&lang=js&"
import style0 from "./fee-lab-kpi-strip.vue?vue&type=style&index=0&id=e9d7b2b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d7b2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9d7b2b6')) {
      api.createRecord('e9d7b2b6', component.options)
    } else {
      api.reload('e9d7b2b6', component.options)
    }
    module.hot.accept("./fee-lab-kpi-strip.vue?vue&type=template&id=e9d7b2b6&scoped=true&", function () {
      api.rerender('e9d7b2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-lab-kpi-strip/fee-lab-kpi-strip.vue"
export default component.exports